import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';

import { CreateTsvModal } from '../../components';
import { hideCreateTsvModal, requestCreateTsv } from '../../actions';

class CreateTsvModalContainer extends Component {
  render() {
    const {
      createTsvModal,
      tsv,
      requestCreateTsv,
      hideCreateTsvModal,
    } = this.props;

    const { isVisible } = createTsvModal;

    if (!isVisible) {
      return null;
    }

    const { error, isLoading } = tsv;

    return (
      <Suspense fallback={<div />}>
        <CreateTsvModal
          onClose={hideCreateTsvModal}
          onCreate={requestCreateTsv}
          error={error}
          loading={isLoading}
        />
      </Suspense>
    );
  }
}

const mapDispatchToProps = {
  hideCreateTsvModal,
  requestCreateTsv,
};

const mapStateToProps = state => ({
  createTsvModal: state.createTsvModal,
  tsv: state.tsv,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTsvModalContainer);
